export const ADD_GOOD = "action.add_goods";
export const CLEAN_GOODS = "action.clean_goods";
export const REMOVE_GOOD = "action.remove_good";
export const DELETE_GOOD = "action.delete_good";
export const CHANGE_FORM = "action.change_form";
export const CHANGE_MULTIPLIER = "action.change_multiplier";

export const CHANGE_CATEGORY = "action.change_category";
